import { CheckmarkFilled, CheckmarkFilledWarning, Incomplete } from "@carbon/icons-react";
import { useModal } from "@flaminem/ui-components";

import MatchElementModal from "src/dynamic-view-renderer/Widgets/RelatedCases/MatchModal/MatchElementModal.tsx";
import { Comparison } from "src/dynamic-view-renderer/Widgets/RelatedCases/relatedCases.typings.ts";
import { useT } from "src/internationalization";

type MatchElementIconProps = {
  comparison?: Comparison;
  title: string;
};

export default function MatchElementIcon({ comparison, title }: MatchElementIconProps) {
  const modalOutput = useModal();
  const t = useT();

  switch (comparison?.match) {
    case "Full": {
      return (
        <MatchElementModal
          subTitle={title}
          title={t("component.widget.related.cases.modal.matched.icon.full.title")}
          modalProps={modalOutput}
          renderTrigger={() => <CheckmarkFilled className="text-supportSuccessInverse" />}
          comparison={comparison}
        />
      );
    }
    case "Partial": {
      return (
        <MatchElementModal
          subTitle={title}
          title={t("component.widget.related.cases.modal.matched.icon.partial.title")}
          modalProps={modalOutput}
          renderTrigger={() => <Incomplete />}
          comparison={comparison}
        />
      );
    }
    case "Cross": {
      return (
        <MatchElementModal
          subTitle={title}
          title={t("component.widget.related.cases.modal.matched.icon.cross.title")}
          modalProps={modalOutput}
          renderTrigger={() => <CheckmarkFilledWarning className="text-supportError" />}
          comparison={comparison}
        />
      );
    }
    default:
      return <div className="text-textSecondary">-</div>;
  }
}
